import React, { forwardRef } from 'react';
const variantToElement = {
    description: 'dl',
    unordered: 'ul',
    ordered: 'ol',
};
const List = forwardRef(function List({ testId = 'store-list', variant = 'unordered', as: MaybeComponent, ...otherProps }, ref) {
    const dataAttributes = {
        'data-testid': testId,
        'data-store-list': variant,
    };
    const Component = MaybeComponent ?? variantToElement[variant] ?? 'ul';
    return React.createElement(Component, Object.assign({ ref: ref }, dataAttributes, otherProps));
});
export default List;
//# sourceMappingURL=List.js.map